// defaults to localStorage for web
import NiceModal from '@ebay/nice-modal-react';
import { configureStore, createAsyncThunk } from '@reduxjs/toolkit';
import { createLogger } from 'redux-logger';

import { Provider } from 'react-redux';

import reducer from 'stores/';

const reducerProxy = (state, action) => {
	if (action.type === 'logout/LOGOUT') {
		localStorage.removeItem('REFRESH_TOKEN');
		localStorage.removeItem('ACCESS_TOKEN');
		localStorage.removeItem('supportAccessUntil');
		localStorage.removeItem('sallaStores');
		localStorage.removeItem('sallaSyncInfo');
		localStorage.removeItem('sallaLastError');
		localStorage.removeItem('sallaUpdateInfo');

		Object.keys(state.modals).forEach((key) => {
			NiceModal.remove(key);
		});

		return reducer({ layout: state.layout }, action);
	}
	return reducer(state, action);
};

export const logout = createAsyncThunk('auth/logout', async (_payload, thunkAPI) => {
	thunkAPI.dispatch({ type: 'logout/LOGOUT' });
});

// Custom logger
const logger = createLogger({
	collapsed: true,

	// to show the difference between what changed in state
	diff: true,

	// to log time
	duration: true,
	timestamp: true,

	// custom colors for each log
	colors: {
		title: () => '#ff0000',
		prevState: () => '#de6f0d',
		action: () => '#6e13ab',
		nextState: () => '#1a9134'
	}
});

export const store = configureStore({
	reducer: reducerProxy,
	middleware:
		import.meta.env.MODE === 'development' || import.meta.env.VITE_BRANCH_NAME
			? (getDefaultMiddleware) => getDefaultMiddleware().concat(logger)
			: undefined,
	devTools: import.meta.env.MODE === 'development' || import.meta.env.VITE_BRANCH_NAME
});

export const ReduxProvider = ({ children }) => (
	<Provider store={store}>
		<NiceModal.Provider>{children}</NiceModal.Provider>
	</Provider>
);
